import { forwardRef } from "react";

import { Slot as SlotPrimitive } from "@radix-ui/react-slot";

import { cn } from "../index";
import { controlSlotVariants, controlVariants } from "./control.variant";

interface RootProps extends React.ComponentPropsWithRef<"div"> {
  error?: boolean;
  rounded?: boolean;
  asChild?: boolean;
}

const Root = forwardRef<HTMLDivElement, RootProps>(
  ({ className, error, rounded = false, asChild = false, ...props }, forwardedRef) => {
    const Comp = asChild ? SlotPrimitive : "div";

    return <Comp {...props} ref={forwardedRef} className={cn(controlVariants({ error, rounded }), className)} />;
  },
);

Root.displayName = "Control.Root";

interface SlotProps extends React.ComponentPropsWithRef<"div"> {
  side?: "left" | "right";
}

const Slot = forwardRef<HTMLDivElement, SlotProps>(({ className, side, ...divProps }, forwardedRef) => (
  <div
    data-control-slot
    data-side={side}
    {...divProps}
    ref={forwardedRef}
    className={cn(controlSlotVariants(), className)}
  />
));

Slot.displayName = "Control.Slot";

export { Root, Slot };
export type { RootProps, SlotProps };
